import Splide from '@splidejs/splide';

class Slider {
	constructor(el) {
		if (el) {
			this.el = el;
			this.slideCount = this.el.querySelectorAll('.splide__slide').length;
			this.splide = new Splide(this.el).mount();
			this.slides = this.el.querySelectorAll('.splide__slide');
			this.arrowsEl = this.el.querySelector('.splide__arrows');

			this.splide.on('move', this.beforeMove);
			this.splide.on('moved', this.afterMove);

			// Handle media content slider conditions.
			if (this.el.classList.contains('em-media-content-slider__inner')) {
				const eyebrow = this.el.querySelector('.em-media-content-slider__header');
				eyebrow.appendChild(this.arrowsEl);
			}

			this.maybeHideArrows();
			window.addEventListener('resize', this.maybeHideArrows);
			this.splide.on('move', this.beforeMove);
			this.splide.on('moved', this.afterMove);
		}
	}

	beforeMove = (newIndex, prevIndex) => {
		let enteringSlide;
		let leavingSlide;

		if (newIndex > prevIndex) {
			enteringSlide = this.el.querySelector('.splide__slide.is-visible + .splide__slide:not(.is-visible)');
			leavingSlide = this.el.querySelector('.splide__slide.is-active');
		} else {
			enteringSlide = this.el.querySelector('.splide__slide.is-prev');
			leavingSlide = this.el.querySelector('.splide__slide.is-visible + .splide__slide:not(.is-visible)')?.previousElementSibling
				?? this.el.querySelector('.splide__slide.is-visible:last-child');
		}

		if (enteringSlide) {
			enteringSlide.classList.add('is-entering');
		}

		if (leavingSlide) {
			leavingSlide.classList.add('is-leaving');
		}
	}

	afterMove = () => {
		const slides = this.el.querySelectorAll('.is-entering, .is-leaving');
		if (slides.length) {
			slides.forEach((slide) => {
				slide.classList.remove('is-entering');
				slide.classList.remove('is-leaving');
			});
		}
	}

	maybeHideArrows = () => {
		window.requestAnimationFrame(() => {
			const splideData = this.el.getAttribute('data-splide');
			const parsedData = JSON.parse(splideData);
			if (parsedData && parsedData.breakpoints) {
				let breakpointKeys = Object.keys(parsedData.breakpoints);
				breakpointKeys = breakpointKeys.map((key) => parseInt(key));
				breakpointKeys = breakpointKeys.sort((a, b) => {
					if (a > b) return 1;
					if (a < b) return -1;
					return 0;
				});

				let currentBreakpoint = false;
				breakpointKeys.every((bp) => {
					if (bp >= window.innerWidth) {
						currentBreakpoint = bp;
						return false;
					}
					return true;
				});
				let bpPerPage = parsedData.perPage;
				if (currentBreakpoint) {
					bpPerPage = parsedData.breakpoints[currentBreakpoint].perPage;
				}
				if (bpPerPage && this.slideCount <= bpPerPage) {
					this.arrowsEl.style.display = 'none';
				} else {
					this.arrowsEl.style.display = '';
				}
			}
		});
	}
}

const sliderEls = [...document.querySelectorAll('.splide[data-splide]')];
if (sliderEls.length) {
	embark.components.splides = sliderEls.map((el) => new Slider(el));
	window.dispatchEvent(
		new CustomEvent('em-slider-mounted', {
			bubbles: true,
			detail: { text: () => Date.now() },
		}),
	);
}
